import ElementPage from "../../Elements";

// pages/OurPolicy.jsx
export default function OurPolicy() {
  return (
    <>
      <div style={styles.container} className="py-2">
        <div className="jtext-justify" style={{ fontFamily: "serif" }}>
          <h6 className="mt-1" style={{ color: "#FF4F00" }}>
            Privacy Policy
          </h6>
          <p className="text-gray-700 fs-6 mb-0">
            This Privacy Policy is issued by Khunkhaar Meldi Maa Bareja Trust.
          </p>
          <b className="text-gray-700 fs-6">1. Information Collected</b>
          <p className="mb-2 text-gray-600">
            We collect name, address, contact details, and payment confirmation
            details.
          </p>

          <b className="text-gray-700 fs-6">2. Use of Information</b>
          <p className="mb-2 text-gray-600">
            Information is used for order processing, delivery, and trust
            communication.
          </p>
          <b className="text-gray-700 fs-6">3. Data Protection</b>
          <p className="mb-2 text-gray-600">
            We take reasonable measures to protect user data.
          </p>

          <b className="text-gray-700 fs-6">4. Third Parties</b>
          <p className="mb-2 text-gray-600">
            Payment gateways and delivery partners may access limited data.
          </p>

          <b className="text-gray-700 fs-6">5. Data Sharing</b>
          <p className="mb-2 text-gray-600">
            We do not sell or rent personal data.
          </p>

          <b className="text-gray-700 fs-6">6. Updates</b>
          <p className="text-gray-600">
            This policy may be updated periodically
          </p>
        </div>
      </div>
      <ElementPage />
    </>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
    lineHeight: "1.7",
  },
};
